var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65625 15.5317C1.65528 9.07809 6.21325 3.52253 12.5427 2.26261C18.8721 1.00269 25.2101 4.38932 27.6805 10.3513C30.151 16.3134 28.0658 23.1903 22.7003 26.7763C17.3347 30.3624 10.1832 29.6588 5.61933 25.0959C3.08214 22.5596 1.65655 19.1192 1.65625 15.5317Z",
    stroke: "white",
    strokeWidth: 2.77422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-4",
    d: "M24.75 25.0977L32.4802 32.8279",
    stroke: "white",
    strokeWidth: 2.77422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.fd1260a5405ed9f3a1fb94a402295b36.svg";
export { ForwardRef as ReactComponent };